<template>
  <div class="relative" :class="inlineClasses">
    <div v-if="label" class="form-label" :class="labelClasses">{{ label }}</div>
    <select :id="id" :name="name" v-model="myValue" class="form-select" :class="selectClasses" :disabled="disabled" @change="$emit('change', myValue)">
      <option v-for="option in options" :value="option.value">{{ option.label }}</option>
    </select>
    <slot name="extra"></slot>
    <field-error-help-length :error="error" :help="help"></field-error-help-length>
  </div>
</template>
<script>
export default {
    name: "my-dropdown",
    props: {
        error: {type: String},
        flatRight: {type: Boolean, default: false},
        help: {type: String},
        id: {type: String},
        label: {type: String},
        name: {type: String},
        options: {type: Array, default: () => []},
        selectClass: {type: String},
        labelClass: {type: String},
        value: {type: [String, Number], default: ''},
        inline: {type: Boolean, default: false},
        disabled: {type: Boolean, default: false},
    },
    data() {
        return {
            myValue: this.value
        };
    },
    computed: {
      inlineClasses() {
        return this.inline ? 'flex mb-4 justify-center items-center' : '';
      },
      labelClasses() {
        return this.labelClass + " " + (this.inline? 'w-1/3' : '');
      },
        selectClasses() {
            let classes = [];
            if (this.selectClass) {
                classes.push(this.selectClass);
            } else {
                classes.push('w-full'); //default class
            }
            if (this.error) {
                classes.push('form-error');
            }
            if (this.label) {
                classes.push('mt-1');
            }
            if (this.inline) {
              classes.push('ml-2');
            }
            if (this.disabled) {
              classes.push('bg-gray-300 text-gray-500');
            }
            return classes;
        }
    },
    watch: {
        value(newValue){
          this.myValue = newValue;
        },
        myValue(newValue) {
            this.$emit('input', newValue);
        },
    },
}
</script>
